export default "__VITE_ASSET__a45030e2__"